module.exports = __webpack_public_path__ + "static/media/list-content.1b3098f9.png";